import { carType } from "constant";

/**
 * Validates if a car should be shown based on its type
 * @param {number} carNumber - The car number to validate
 * @param {string} updatedCarDataString - JSON string of car data from global state
 * @returns {boolean} - Returns false if car is a member car, true otherwise
 */
export const validateCarType = (carNumber, updatedCarDataString) => {
  try {
    if (!updatedCarDataString || Object.keys(updatedCarDataString).length == 0) return false;
    
    const parsedCarData = JSON.parse(updatedCarDataString);
    const car = parsedCarData?.filter(car => car?.Car?.CarNumber === carNumber);
    
    if (car?.length <= 0) {
      return false;
    }
    else if (car[0]?.Car?.CarType === carType.member) {
      return false;
    }
    return true;
  } catch (error) {
    console.error("Error parsing car data in validateCarType:", error);
    return false;
  }
};